/* Rise8 product page — gallery, swatches and the quantity stepper.

   Ported from design/build/product_build.py GALLERY_JS and extended for real Shopify variants.

   The one behaviour worth stating: the gallery and the swatches drive each other BOTH ways.
   Choosing a colour swaps the hero and selects that thumbnail; choosing a colour thumbnail
   moves the swatch. Thumbnails with no colour — the box shots — swap the image without
   disturbing the colour choice, which is why this keys on a data attribute and never on
   thumbnail index.

   Variant matching reads the JSON blob, not the rendered labels: an option value with a
   trailing space or an ampersand matches itself in JSON and does not match its own innerText.
*/
(function () {
  var root = document.querySelector('.mk-pdp');
  if (!root) return;

  var hero = root.querySelector('#mk-hero');
  var thumbs = [].slice.call(root.querySelectorAll('.mk-gal-t'));
  var swatches = [].slice.call(root.querySelectorAll('.mk-sw'));
  var idInput = root.querySelector('#rise8-product-form input[name="id"]');
  var priceEl = root.querySelector('.mk-pdp-price');
  var blob = root.querySelector('[data-rise8-variants]');
  var variants = [];
  try { variants = JSON.parse(blob.textContent); } catch (e) { variants = []; }

  function selected() {
    return swatches.filter(function (s) { return s.classList.contains('is-on'); })
                   .map(function (s) { return s.dataset.value; });
  }

  function showThumb(btn) {
    if (!btn || !hero) return;
    /* Shopify's image_tag emits a srcset, and a browser with a srcset picks from it and
       ignores src. Setting src alone changed the attribute and nothing on screen — which is
       exactly what a probe reading getAttribute('src') reports as success. Swap BOTH, srcset
       first so the candidate list is never briefly inconsistent with the fallback. */
    if (btn.dataset.srcset !== undefined) hero.srcset = btn.dataset.srcset || '';
    if (btn.dataset.full) hero.src = btn.dataset.full;
    var img = btn.querySelector('img');
    if (img && img.alt) hero.alt = img.alt;
    thumbs.forEach(function (t) { t.classList.toggle('is-on', t === btn); });
  }

  function thumbForColour(value) {
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].dataset.color === value) return thumbs[i];
    }
    return null;
  }

  function money(cents) {
    return '$' + Math.floor(cents / 100) + '.' + ('0' + (cents % 100)).slice(-2);
  }

  function sync() {
    var chosen = selected();
    if (!chosen.length || !variants.length) return;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null; });
      var match = chosen.every(function (c, n) { return opts[n] === c; });
      if (!match) continue;
      if (idInput) idInput.value = v.id;
      if (priceEl && typeof v.price === 'number') priceEl.textContent = money(v.price);
      /* Keep the address bar in step so a shared link opens on the same variant, the way
         Dawn's variant-selects does. replaceState, not pushState — a colour is not a
         navigation and should not need a back press to undo. */
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* older browsers: the form still submits the right id */ }
      return;
    }
  }

  swatches.forEach(function (sw) {
    sw.addEventListener('click', function () {
      var group = swatches.filter(function (o) { return o.dataset.option === sw.dataset.option; });
      group.forEach(function (o) {
        var on = o === sw;
        o.classList.toggle('is-on', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var t = thumbForColour(sw.dataset.value);
      if (t) showThumb(t);
      sync();
    });
  });

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      showThumb(t);
      /* Only a colour-bearing thumbnail moves the swatch. The box shots deliberately do not. */
      if (!t.dataset.color) return;
      var sw = swatches.filter(function (o) { return o.dataset.value === t.dataset.color; })[0];
      if (sw && !sw.classList.contains('is-on')) sw.click();
    });
  });

  var qty = root.querySelector('#mk-pdp-qty');
  if (qty) {
    var field = qty.querySelector('.mk-qty-n');
    qty.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-step]');
      if (!b || !field) return;
      var next = parseInt(field.value, 10) + parseInt(b.getAttribute('data-step'), 10);
      field.value = next < 1 ? 1 : next;   /* never below one; removal is the cart's job */
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
})();
